import {
  getOverlayDisplayValues,
  OverlayUtil
} from "@tldraw/editor";
class BrushOverlayUtil extends OverlayUtil {
  static type = "brush";
  options = {
    zIndex: 300,
    getDefaultDisplayValues(editor, _overlay, theme, colorMode) {
      const colors = theme.colors[colorMode];
      return {
        fillColor: colors.brushFill,
        strokeColor: colors.brushStroke,
        lineWidth: 1
      };
    },
    getCustomDisplayValues() {
      return {};
    }
  };
  isActive() {
    return this.editor.getInstanceState().brush !== null;
  }
  getOverlays() {
    const brush = this.editor.getInstanceState().brush;
    if (!brush) return [];
    return [
      {
        id: "brush",
        type: "brush",
        props: {
          x: brush.x,
          y: brush.y,
          w: Math.max(1, brush.w),
          h: Math.max(1, brush.h)
        }
      }
    ];
  }
  render(ctx, overlays) {
    const overlay = overlays[0];
    if (!overlay) return;
    const { x, y, w, h } = overlay.props;
    const zoom = this.editor.getZoomLevel();
    const dv = getOverlayDisplayValues(this, overlay);
    ctx.fillStyle = dv.fillColor;
    ctx.fillRect(x, y, w, h);
    ctx.lineWidth = dv.lineWidth / zoom;
    ctx.strokeStyle = dv.strokeColor;
    ctx.strokeRect(x, y, w, h);
  }
  renderMinimap(ctx, overlays, zoom) {
    const overlay = overlays[0];
    if (!overlay) return;
    const { x, y, w, h } = overlay.props;
    const dv = getOverlayDisplayValues(this, overlay);
    ctx.fillStyle = dv.fillColor;
    ctx.fillRect(x, y, w, h);
    ctx.lineWidth = dv.lineWidth / zoom;
    ctx.strokeStyle = dv.strokeColor;
    ctx.strokeRect(x, y, w, h);
  }
}
export {
  BrushOverlayUtil
};
//# sourceMappingURL=BrushOverlayUtil.mjs.map
